import { render } from "./BaseCardV2.vue?vue&type=template&id=2468b64d"
import script from "./BaseCardV2.vue?vue&type=script&lang=js"
export * from "./BaseCardV2.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__